"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upperFirstLetter = exports.trimDecimals = exports.toUpper = exports.toLower = exports.toBinary = exports.split = exports.safeTrim = exports.safeSlice = exports.lowerFirstLetter = exports.isValidURL = exports.getjsx = exports.equalsInsensitive = exports.composeEnumerableString = exports.cleanBlanks = exports.camelcase = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _objects = require("../objects");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var toUpper = exports.toUpper = function toUpper() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return R.toUpper(string);
};
var toLower = exports.toLower = function toLower() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return R.toLower(string);
};
var split = exports.split = function split() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return string.split(separator);
};
var equalsInsensitive = exports.equalsInsensitive = R.curry(function (a, b) {
  return String(a).toLowerCase() === String(b).toLowerCase();
});
var composeEnumerableString = exports.composeEnumerableString = function composeEnumerableString(list, separator, lastSeparator) {
  var result = '';
  if (list.length < 2) {
    return R.concat(result, R.prop(0, list));
  }
  if (list.length > 2) {
    result += R.join(separator, R.slice(0, list.length - 2, list)) + separator;
  }
  if (lastSeparator) {
    result += R.join(lastSeparator, R.slice(list.length - 2, list.length, list));
  }
  return result;
};
var camelcase = exports.camelcase = function camelcase(string) {
  return string ? string.replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
    return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
  }).replace(/\s+/g, '') : '';
};
var upperFirstLetter = exports.upperFirstLetter = function upperFirstLetter(string) {
  return typeof string === 'string' ? toUpper(string.charAt(0)) + string.slice(1) : string;
};
var lowerFirstLetter = exports.lowerFirstLetter = function lowerFirstLetter(string) {
  return typeof string === 'string' ? toLower(string.charAt(0)) + string.slice(1) : string;
};
var safeTrim = exports.safeTrim = function safeTrim() {
  var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return item && item.trim ? item.trim() : item;
};
var safeSlice = exports.safeSlice = function safeSlice() {
  var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var start = arguments.length > 1 ? arguments[1] : undefined;
  var end = arguments.length > 2 ? arguments[2] : undefined;
  return item && item.slice ? item.slice(start, end) : item;
};
var getjsx = exports.getjsx = function getjsx(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    _ref$pattern = _ref.pattern,
    pattern = _ref$pattern === void 0 ? '%' : _ref$pattern,
    _ref$map = _ref.map,
    map = _ref$map === void 0 ? {} : _ref$map;
  return label.split(pattern).map(function (item) {
    if (R.prop(item, map)) {
      return map[item];
    }
    return item;
  });
};
var trimDecimals = exports.trimDecimals = function trimDecimals(value) {
  var maxDecimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  if ((0, _objects.isBlank)(value)) return '';
  var stringValue = value.toString();
  var decimalPointIndex = stringValue.indexOf('.');
  if (decimalPointIndex === -1) return stringValue;

  // We add 1 since the decimalPointIndex is zero-indexed
  decimalPointIndex += 1;
  var decimalCount = stringValue.length - decimalPointIndex;
  if (decimalCount === 0) return R.init(stringValue); // remove the trailing decimal point
  if (decimalCount < 3) return stringValue; // no need for trimming
  return R.slice(0, decimalPointIndex + maxDecimals, stringValue);
};
var cleanBlanks = exports.cleanBlanks = function cleanBlanks() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var replaceWith = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return string.replace(/\s/g, replaceWith);
};
var isValidURL = exports.isValidURL = function isValidURL(string) {
  var res = string.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g);
  return res !== null;
};
var toBinary = exports.toBinary = function toBinary(string) {
  if ((0, _objects.isBlank)(string)) return '';
  var codeUnits = new Uint16Array(string.length);
  for (var i = 0; i < codeUnits.length; i += 1) {
    codeUnits[i] = string.charCodeAt(i);
  }
  return btoa(String.fromCharCode.apply(String, _toConsumableArray(new Uint8Array(codeUnits.buffer))));
};